<template>
  <!-- 配货拆分-核查上架唛头打印 -->
  <div class="check-put-on-shelves-label">
    <table class="label-table" cellspacing="0" cellpadding="0">
      <tr>
        <td class="top-cell" colspan="4">
          <div class="badge" v-if="viewData.level">{{ viewData.level }}</div>
          <div class="date">打印日期：{{ viewData.print_date }}</div>
          <div class="customer">
            <span class="customer-lab">客户名：</span>
            <span class="customer-val">{{ viewData.user_name }}</span>
          </div>
        </td>
      </tr>
      <tr class="code-row">
        <td class="grid-number" colspan="2">库位：{{ viewData.grid_number }}</td>
        <td class="product-code" colspan="2">商品码：{{ viewData.product_code }}</td>
      </tr>
      <tr>
        <td class="detail-cell" colspan="4">
          <table class="detail-table" cellspacing="0" cellpadding="0">
            <tr>
              <td class="detail-label">订单编号：</td>
              <td class="order-value">{{ viewData.order_sn }}</td>
              <td class="sorting-value">{{ viewData.sorting }}番</td>
            </tr>
            <tr>
              <td class="detail-label attr-label">商品属性：</td>
              <td class="attr-value" colspan="2">{{ viewData.attribute }}</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td class="barcode-cell" colspan="4">
          <canvas ref="barcode" width="1000" height="174"></canvas>
        </td>
      </tr>
      <tr class="sign-row">
        <td class="sign-title">核查员：</td>
        <td class="sign-name">{{ viewData.checker_name }}</td>
        <td class="sign-title">采购员：</td>
        <td class="sign-name">{{ viewData.purchaser_name }}</td>
      </tr>
      <tr class="sign-row">
        <td class="sign-title">业务员：</td>
        <td class="sign-name">{{ viewData.salesman_name }}</td>
        <td class="sign-title">检品员：</td>
        <td class="sign-name">{{ viewData.inspector_name }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CheckPutOnShelvesLabel',
  props: {
    labelData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    viewData() {
      const data = this.labelData || {}
      return {
        print_date: data.print_date || '',
        level: data.level || '',
        user_name: data.user_name || '',
        grid_number: data.grid_number || '',
        product_code: data.product_code || '',
        order_sn: data.order_sn || '',
        sorting: data.sorting || '',
        attribute: data.attribute || '',
        checker_name: data.checker_name || '',
        purchaser_name: data.purchaser_name || '',
        salesman_name: data.salesman_name || '',
        inspector_name: data.inspector_name || ''
      }
    }
  },
  mounted() {
    this.createBarcode()
  },
  watch: {
    labelData: {
      deep: true,
      handler() {
        this.$nextTick(this.createBarcode)
      }
    }
  },
  methods: {
    createBarcode() {
      if (!this.$refs.barcode || !this.viewData.order_sn) return
      JsBarcode(this.$refs.barcode, this.viewData.order_sn, {
        format: 'CODE128',
        displayValue: false,
        height: 174,
        width: 3,
        margin: 0,
        lineColor: '#000000'
      })
    }
  }
}
</script>

<style scoped>
.check-put-on-shelves-label {
  width: 1080px;
  height: 1600px;
  color: #000;
  background: #fff;
  font-family: "Microsoft YaHei", SimHei, Arial, sans-serif;
  overflow: hidden;
}

.label-table {
  width: 1080px;
  height: 1600px;
  table-layout: fixed;
  border-collapse: collapse;
  border: 5px solid #000;
  background: #fff;
}

.label-table td {
  box-sizing: border-box;
  color: #000;
  vertical-align: middle;
}

.top-cell {
  position: relative;
  height: 360px;
  padding: 35px 40px 0;
  vertical-align: top !important;
}

.badge {
  float: right;
  min-width: 150px;
  padding: 30px 50px;
  margin: -35px -40px 0 30px;
  background: #000;
  color: #fff !important;
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
  text-align: center;
}

.date {
  font-size: 32px;
  line-height: 40px;
}

.customer {
  clear: both;
  padding-top: 80px;
  font-size: 48px;
  line-height: 58px;
  white-space: nowrap;
}

.customer-val {
  font-weight: 700;
}

.code-row td {
  height: 150px;
  border-top: 5px solid #000;
  border-bottom: 5px solid #000;
  font-size: 60px;
  font-weight: 700;
  line-height: 70px;
  text-align: center;
}

.grid-number {
  width: 420px;
  border-right: 5px solid #000;
}

.product-code {
  width: 660px;
}

.detail-cell {
  height: 505px;
  padding: 80px 40px 0;
  vertical-align: top !important;
}

.detail-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.detail-table td {
  font-size: 40px;
  line-height: 54px;
  vertical-align: top;
}

.detail-label {
  width: 240px;
  font-weight: 400;
  white-space: nowrap;
}

.order-value {
  width: 560px;
  font-weight: 700;
}

.sorting-value {
  width: 180px;
  font-weight: 700;
  text-align: right;
}

.attr-label {
  padding-top: 80px;
}

.attr-value {
  padding-top: 80px;
  font-weight: 700;
  word-break: break-all;
}

.barcode-cell {
  height: 340px;
  padding: 80px 40px 86px;
  text-align: center;
  vertical-align: top !important;
}

.barcode-cell canvas {
  display: block;
  width: 1000px !important;
  height: 174px !important;
}

.sign-row td {
  height: 114px;
  padding: 28px 40px;
  border-top: 5px solid #000;
  font-size: 40px;
  line-height: 54px;
  white-space: nowrap;
}

.sign-row td+td {
  border-left: 5px solid #000;
}

.sign-title {
  width: 240px;
}

.sign-name {
  width: 300px;
}

@media print {

  .check-put-on-shelves-label,
  .label-table {
    width: 1080px;
    height: 1600px;
  }

  .check-put-on-shelves-label {
    page-break-after: always;
  }
}
</style>
